const props = props => ({
  activateItem: item => {
    props.setAnchor(null)

    if (item.path) {
      props.history.push(item.path)
    } else if (item.external) {
      window.location.assign(item.external)
    } else if (item.modal) {
      props.modalOpenDispatch(item.modal)
    } else if (item.action) {
      if (props[`${item.action}Dispatch`]) {
        props[`${item.action}Dispatch`]()
      }
    } else if(item.request) {
      item.request()
    }
  }
})

export default props
